import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Zap, X } from "lucide-react";

const DISMISS_KEY = "generation_progress_dismissed";

export default function GenerationProgressBanner() {
    const { user, planSubscriptions } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem(DISMISS_KEY) === "true"
    );

    if (dismissed || !user) return null;

    const count = user?.company?.codeGenerationCount || 0;
    const hasSubscription = planSubscriptions?.some(
        (s) => s.status === "ACTIVE" || s.status === "TRIALING"
    );

    if (count < 1 || count >= 10 || hasSubscription) return null;

    const remaining = 10 - count;
    let messageKey = "generationProgress.early";
    if (count >= 4 && count <= 6) messageKey = "generationProgress.halfway";
    if (count >= 7) messageKey = "generationProgress.almost";

    const handleCta = () => {
        const lastId = localStorage.getItem("last_workflow_id");
        navigate(lastId ? `/chat/${lastId}/chat` : "/chat");
    };

    return (
        <div className="bg-indigo-50 text-indigo-900 px-4 py-2 text-sm relative pr-8">
            <div className="flex items-center justify-center gap-2 flex-wrap">
                <Zap className="h-4 w-4 shrink-0 text-indigo-600" />
                <span className="text-center">{t(messageKey, { count, remaining })}</span>
                <div className="flex items-center gap-2 shrink-0">
                    <div className="w-16 h-1.5 bg-indigo-200 rounded-full overflow-hidden">
                        <div className="h-full bg-indigo-600 rounded-full transition-all" style={{ width: `${(count / 10) * 100}%` }} />
                    </div>
                    <span className="text-xs text-indigo-500 font-medium">{count}/10</span>
                </div>
                <button onClick={handleCta} className="underline font-medium hover:opacity-80 text-indigo-700 shrink-0">
                    {t("generationProgress.cta")}
                </button>
            </div>
            <button
                onClick={() => { sessionStorage.setItem(DISMISS_KEY, "true"); setDismissed(true); }}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:opacity-70"
                aria-label={t("common.close")}
            >
                <X className="h-4 w-4" />
            </button>
        </div>
    );
}
